import Link from 'next/link'
import { FlexColumn } from '@/atoms/FlexContainers'
import { LightIcon } from '@/atoms/Icons/LightIcon'
import { ParagraphXL } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export const InfoSection = () => {
  const { t } = useTranslate('about')
  return (
    <section className="bg-gray-800 px-12 py-24 text-center md:px-32">
      <FlexColumn className="mx-auto gap-4 lg:max-w-[750px] 2xl:max-w-[1000px]">
        <LightIcon color="white" className="self-center" size={48} />
        <Translate t={t} i18nKey="latestBoxOfficeHitv2">
          <ParagraphXL className="lg:photon-heading-sm">
            Our biggest box-office hit{' '}
            <Link className="italic underline" href={paths.movies.soundOfFreedom}>
              Sound of Freedom
            </Link>{' '}
            has sparked{' '}
            <Link className="italic underline" href={paths.blog.ripplesOfFreedom}>
              long-awaited conversations about trafficking
            </Link>{' '}
            and brought light to even the darkest corners of the world.
          </ParagraphXL>
        </Translate>
      </FlexColumn>
    </section>
  )
}
